
import httpClient from "@/plugins/axios";

export const getUsers = async (page, pageSize) => {
    const response = await httpClient.get(`/v1/users/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}

export const getNewUsers = async () => {
    const response = await httpClient.get(`/v1/users/new/`);
    return response;
}

export const getNotLoggedInUsers = async () => {
    const response = await httpClient.get(`/v1/users/notloggedin/`);
    return response;
}

export const getAdmins = async (page, pageSize) => {
    const response = await httpClient.get(`/v1/tenant/admins/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}

export const getUser = async (userId) => {

    const response = await httpClient.get(`/v1/users/${userId}/?admin_view=1`);
    return response;
}

export const getUserGroups = async (userId) => {
    const response = await httpClient.get(`/v1/users/${userId}/groups/?admin_view=1`);
    return response;
}

export const getUserAdminGroups = async (userId) => {
    const response = await httpClient.get(`/v1/users/${userId}/admingroups/?admin_view=1`);
    return response;
}

export const searchUsers = async (query) => {
    const response = await httpClient.get(`/v1/people/search/?search=${encodeURIComponent(query)}&admin_view=1`);
    return response;
}

export const importUser = async (user) => {
    const response = await httpClient.post(`/v1/users/import/?admin_view=1`, user);
    return response;
}

export const saveUser = async (user) => {
    if (user.id) {
        const response = await updateUser(user);
        return response;
    }
    else {
        const response = await insertUser(user);
        return response;
    }
}

export const removeUser = async (userId) => {
    const response = await httpClient.delete(`/v1/users/${userId}/?admin_view=1`);
    return response;
}

export const updateUserImage = async (userId, imageBlob, imageName) => {
    const formData = new FormData();
    formData.append("image", imageBlob, imageName);

    const response = await httpClient.put(`/v1/users/${userId}/image/`, formData);
    return response;
}

export const removeUserImage = async (userId) => {
    const response = await httpClient.put(`/v1/users/${userId}/image/`,
        {
            remove_image: true
        });
    return response;
}

export const getTenantAdmins = async (page, pageSize) => {
    const response = await httpClient.get(`/v1/tenant/admins/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}

// Both tenant and group admins
export const getAllAdmins = async () => {
    const response = await httpClient.get(`/v1/tenant/all-admins/?page_size=50`);
    return response;
}

export const inviteUser = async (userId, message) => {
    const response = await httpClient.post(`/v1/users/invite/?admin_view=1`, {
        'id': userId,
        message
    });
    return response;
}

const insertUser = async (user) => {
    return await httpClient.post(`/v1/users/?admin_view=1`, user);
}

const updateUser = async (user) => {
    return await httpClient.put(`/v1/users/${user.id}/?admin_view=1`, user);
}

